import { Verify } from './Verify';
import { Home } from './Home';
import { Privacy } from './Privacy';
import { Setup } from './Setup';
import { Terms } from './Terms';
import { useLocation, useScrollToHash } from './router';

const API_BASE = import.meta.env.VITE_API_BASE ?? 'https://api.vocalcord.io';

export function App() {
  const { pathname, search, hash } = useLocation();
  useScrollToHash(hash, pathname);

  // Verification: ?code=… can be appended to any path. Keep precedence
  // so emailed links work whether the user lands on / or /pricing etc.
  const code = new URLSearchParams(search).get('code');
  if (code) {
    return <Verify apiBase={API_BASE} code={code} />;
  }

  if (pathname === '/privacy') return <Privacy />;
  if (pathname === '/setup') return <Setup apiBase={API_BASE} />;
  if (pathname === '/terms') return <Terms />;

  // Single-page site: every other path renders Home.
  return <Home apiBase={API_BASE} />;
}
